import { ConfirmDeleteDialog } from "@/components/shared/ConfirmDeleteDialog";
import { productApi } from "@/resources/product";

export interface DeleteHeroAsinTarget {
  id: number;
  name: string;
}

interface DeleteHeroAsinDialogProps {
  asin: DeleteHeroAsinTarget | null;
  brandId: number;
  onCancel: () => void;
  onDeleted?: () => void;
}

export function DeleteHeroAsinDialog({ asin, brandId, onCancel, onDeleted }: DeleteHeroAsinDialogProps) {
  const { mutate: deleteHeroProduct } = productApi.useDeleteHeroProduct();

  const handleDelete = () => {
    if (!asin) return;

    onDeleted?.();

    deleteHeroProduct({ productId: asin.id, brandId });
  };

  return (
    <ConfirmDeleteDialog
      open={!!asin}
      onOpenChange={(open) => { if (!open) onCancel(); }}
      title={`Delete "${asin?.name}"?`}
      description={`This will permanently remove "${asin?.name}" and all associated landscapes, keywords, A/B tests, and analytics data. This action cannot be undone.`}
      onConfirm={handleDelete}
    />
  );
}
